import { render } from "./TlbsAlumniRenewalComponent.vue?vue&type=template&id=363c62c0&scoped=true&ts=true"
import script from "./TlbsAlumniRenewalComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsAlumniRenewalComponent.vue?vue&type=script&lang=ts"

import "./TlbsAlumniRenewalComponent.vue?vue&type=style&index=0&id=363c62c0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-363c62c0"]])

export default __exports__